import React, { forwardRef, Ref } from 'react';
import DropdownItem from './DropdownItem';
import { FiAirplay, FiLogOut, FiBell } from 'react-icons/fi';

interface DropdownNavigationProps {
  // define your props here
  classes: string;
  handleLogout?: () => void;
}

const DropdownNavigation = forwardRef<HTMLDivElement, DropdownNavigationProps>(
  ({ classes, handleLogout }, ref) => {
    const dropdownMenu = [
      {
        label: 'Landing Page',
        router: '/',
        icon: <FiAirplay />
      },
      {
        label: 'Logout',
        router: '/logout',
        icon: <FiLogOut />,
        handleLogout: () => handleLogout()
      }
    ];
    return (
      <div ref={ref} className={classes}>
        {dropdownMenu.map((item, index) => {
          return <DropdownItem key={index} {...item} />;
        })}
      </div>
    );
  }
);

export default DropdownNavigation;
